<template lang="pug">
modal-window.modal-show-image(:width='900', :height='600', ref='modal')
  .modal-show-image__inner
    image-base.modal-show-image__inner__image(:src='imageUrl')
    .modal-show-image__inner__close
      fa-icon.modal-show-image__inner__close__icon(icon='times', @click='hide')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/student/ModalWindow.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * 画像表示モーダル
 */
@Component({
  components: {
    ModalWindow,
    ImageBase,
  },
})
export default class ModalShowImage extends Vue {
  // 画像url
  @Prop()
  imageUrl!: string

  @Ref() modal!: ModalWindow

  public show() {
    this.modal.show()
  }

  private hide() {
    this.modal.hide()
  }
}
</script>

<style lang="stylus" scoped>
.modal-show-image
  &__inner
    height 580px
    width 880px
    padding 10px
    &__image
      width 100%
      height 100%
      object-fit contain
    &__close
      position absolute
      top 10px
      right 15px
      &__icon
        height 40px
        cursor pointer
</style>
